import React from 'react';

import Catalog from 'files/Catalog.js';
import ProductDetail from 'views/site/ProductDetail.js';
import ProductGrid from 'views/site/ProductGrid.js';

/*
 * Products
 *
 * One view serving two URLs, because the route module addresses views by
 * query parameter rather than by path:
 *
 *   ?route=products                        the grid
 *   ?route=products&handle=water-sensor    that product's detail page
 *
 * When path-based routing arrives these become two routes and this file
 * becomes two entries in a router. Nothing else has to change.
 */

const Products = ({ dealership, onAddToQuote, onOpenQuiz, params, utils }) => {

    let mode = Catalog.getMode(dealership);
    let products = Catalog.getAll(mode);
    let handle = params?.handle;

    const onBack = () => {
        utils.navigation.set({ key: 'products', view: 'products' });
    }

    const onViewDetails = product => {
        utils.navigation.set({
            key: 'products',
            params: { handle: product.handle },
            view: 'products'
        });
    }

    if(handle) {
        return (
            <ProductDetail
            onAddToQuote={onAddToQuote}
            onBack={onBack}
            product={Catalog.getByHandle(handle, mode)} />
        )
    }

    return (
        <div
        className={'site'}
        style={{ width: '100%' }}>
            <ProductGrid
            dealership={dealership}
            onAddToQuote={onAddToQuote}
            onOpenQuiz={onOpenQuiz}
            onViewDetails={onViewDetails}
            products={products}
            standalone={true} />
        </div>
    )
}

export default Products;
